import(/* webpackMode: "eager", webpackExports: ["OurWorkContent"] */ "/vercel/path0/src/components/our-work/OurWorkContent.tsx");
